import axios from 'axios';
import { APP_SETTINGS } from '../../config';

export function getSalaryEmployeeList() {
    return axios.post(APP_SETTINGS.API_PATH.EMPLOYEE.getEmployeeForSalary)
}

export function blockOrUnblockEmployee(empId) {
    return axios.post(APP_SETTINGS.API_PATH.EMPLOYEE.blockOrUnblockEmployee, {
        "userId": empId
    })
}